export default "__VITE_ASSET__i_0_ndtx__"